import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class IconsService {
    /**
     * Constructor
     */
    constructor() {
        const domSanitizer = inject(DomSanitizer);
        const matIconRegistry = inject(MatIconRegistry);

        // Register icon sets
        matIconRegistry.addSvgIconSet(
            domSanitizer.bypassSecurityTrustResourceUrl(
                'icons/material-twotone.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'mat_outline',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'icons/material-outline.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'mat_solid',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'icons/material-solid.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'feather',
            domSanitizer.bypassSecurityTrustResourceUrl('icons/feather.svg')
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'heroicons_outline',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'icons/heroicons-outline.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'heroicons_solid',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'icons/heroicons-solid.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'heroicons_mini',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'icons/heroicons-mini.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'specifics',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'icons/specifics.svg'
            )
        );

        // Register individual icons
        matIconRegistry.addSvgIcon(
            'google',
            domSanitizer.bypassSecurityTrustResourceUrl('icons/google.svg')
        );
        this.registerSpecificsIcons(matIconRegistry, domSanitizer);
    }

    /**
     * Automatically register all icons from the specifics folder
     */
    private registerSpecificsIcons(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer): void {
        // List of all icons in the specifics folder
        const specificsIcons = [
            'add-category', 'add_dish', 'annuler', 'appearance', 'arrow-left', 'back',
            'caret_down', 'caret_up', 'close', 'copy', 'create', 'delete', 'down',
            'download', 'establishment', 'eye', 'facebook', 'galerie', 'guide_tour',
            'image', 'info', 'instagram', 'language_menu', 'log_out', 'menu',
            'modify', 'more_points_vertical', 'pdf', 'printer', 'qr-code', 'refaire',
            'refresh', 'rename', 'reviews', 'save', 'search', 'settings', 'snapchat',
            'social', 'statistiques', 'support', 'timer', 'twitter-alt', 'up',
            'upload', 'user', 'wifi'
        ];

        // Register each icon with the 'specifics' namespace
        specificsIcons.forEach(iconName => {
            matIconRegistry.addSvgIconInNamespace(
                'specifics',
                iconName,
                domSanitizer.bypassSecurityTrustResourceUrl(`icons/specifics/${iconName}.svg`)
            );
        });
    }
}
